/**
 * @file annotationsSavePrep.js
 * @description finds 'dirty' annotations and collects them
 *              in an array to send to the server to save
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Sep 16, 2023 10:58
 */
import { arrayExists, objectExists, objectKeyExists } from 'src/@common/utilities';

function annotationsSavePrep(annotationGroup) {

    const revisedAnnotations = [];

    if (objectKeyExists(annotationGroup, 'annotationObjs') &&
        arrayExists(annotationGroup.annotationObjs)) {

        annotationGroup.annotationObjs.forEach((annotationObj) => {

            if (objectKeyExists(annotationObj, 'dirty') &&
                annotationObj.dirty === true) {

                if (objectKeyExists(annotationObj, 'annotation') &&
                    objectExists(annotationObj.annotation)) {

                    revisedAnnotations.push(annotationObj.annotation);
                }
            }
        });

    }

    return revisedAnnotations;
}

export default annotationsSavePrep;